export default __webpack_public_path__ + "static/warning-messages-confirm-dont-2f3da4a4badbb14e79fe33c28d9dead6a29c9a0f2b09e44e83dc1fdaddba7b3e.png";